/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:29:23
 * @LastEditTime: 2023-07-24 16:59:50
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\work-center\modules\selfReportDataRouter.js
 * 自报数据
 */
const selfReportDataRouter = [
  // 医院药店自报数据 meta_type 1-药店 2-医院
  {
    path: '/behaviorManage/self-report-list/:meta_type',
    name: 'behaviorManageSelfReportList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/self-report/List'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/self-report-data/hos-pha-dis-chain/Page.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '自报数据', //二级菜单
      isMoreMeta: true,
      1: {
        title: '药店自报',
      },
      2: {
        title: '医院自报',
      },
      3: {
        title: '连锁总部自报数据',
      },
      4: {
        title: '配送商自报数据',
      },
      7: {
        title: '基层自报数据',
      },
    },
  },
  // 医院药店自报数据 导入 meta_type 1-药店 2-医院
  {
    path: '/behaviorManage/self-report-import/:meta_type',
    name: 'behaviorManageSelfReportImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/self-report/Import'
      // ), //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/self-report-data/hos-pha-dis-chain/Import.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '自报数据', //二级菜单
      isMoreMeta: true,
      1: {
        title: '导入自报数据',
        breadcrumb: [{
          title: '药店自报',
          name: 'behaviorManageSelfReportList',
        },],
      },
      2: {
        title: '导入自报数据',
        breadcrumb: [{
          title: '医院自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      3: {
        title: '导入自报数据',
        breadcrumb: [{
          title: '连锁总部自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      4: {
        title: '导入自报数据',
        breadcrumb: [{
          title: '配送商自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      7: {
        title: '导入自报数据',
        breadcrumb: [{
          title: '基层自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
    },
  },
  // 医院药店导出自报明细 meta_type 1-药店 2-医院
  {
    path: '/behaviorManage/self-report-export/:meta_type',
    name: 'behaviorManageSelfReportExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/self-report/Export'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/self-report-data/hos-pha-dis-chain/ExportDetail.vue'
      ),  //新迁移文件
    meta: {
      isMoreMeta: true,
      1: {
        title: '导出自报明细',
        breadcrumb: [{
          title: '药店自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      2: {
        title: '导出自报明细',
        breadcrumb: [{
          title: '医院自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      3: {
        title: '导出自报明细',
        breadcrumb: [{
          title: '连锁总部自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      4: {
        title: '导出自报明细',
        breadcrumb: [{
          title: '配送商自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      7: {
        title: '导出自报明细',
        breadcrumb: [{
          title: '基层自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
    },
  },
  // 导出自报统计
  {
    path: '/behaviorManage/self-report-export2/:meta_type',
    name: 'behaviorManageSelfReportExport2',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/self-report/Export2'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/self-report-data/hos-pha-dis-chain/ExportStatistic.vue'
      ),  //新迁移文件
    meta: {
      isMoreMeta: true,
      1: {
        title: '导出自报统计',
        breadcrumb: [{
          title: '自报数据',
          name: 'behaviorManageSelfReportList',
        },
        {
          title: '药店自报',
          name: 'behaviorManageSelfReportList',
        },
        ],
      },
      2: {
        title: '导出自报统计',
        breadcrumb: [{
          title: '自报数据',
          name: 'behaviorManageSelfReportList',
        },
        {
          title: '医院自报',
          name: 'behaviorManageSelfReportList',
        },
        ],
      },
      3: {
        title: '导出自报统计',
        breadcrumb: [{
          title: '自报数据',
          name: 'behaviorManageSelfReportList',
        },
        {
          title: '连锁总部自报',
          name: 'behaviorManageSelfReportList',
        },
        ],
      },
      4: {
        title: '导出自报统计',
        breadcrumb: [{
          title: '自报数据',
          name: 'behaviorManageSelfReportList',
        },
        {
          title: '配送商自报',
          name: 'behaviorManageSelfReportList',
        },
        ],
      },
      7: {
        title: '导出自报统计',
        breadcrumb: [{
          title: '自报数据',
          name: 'behaviorManageSelfReportList',
        },
        {
          title: '基层自报',
          name: 'behaviorManageSelfReportList',
        },
        ],
      },
    },
  },
  // 医院药店自报数据 全年数据 meta_type 1-药店 2-医院
  {
    path: '/behaviorManage/self-report-year/:meta_type/:client_id/:goods_id/:year/:activeKey/:department_id/:quarter_id',
    name: 'behaviorManageSelfReportYearData',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/self-report/YearData.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/self-report-data/hos-pha-dis-chain/AnnualData.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '自报数据', //二级菜单
      isMoreMeta: true,
      1: {
        title: '药店自报全年总数据',
        breadcrumb: [{
          title: '药店自报',
          name: 'behaviorManageSelfReportList',
        },],
      },
      2: {
        title: '医院自报全年总数据',
        breadcrumb: [{
          title: '医院自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      3: {
        title: '连锁总部自报全年总数据',
        breadcrumb: [{
          title: '连锁总部自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      4: {
        title: '配送商自报全年总数据',
        breadcrumb: [{
          title: '配送商自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
      7: {
        title: '基层自报全年总数据',
        breadcrumb: [{
          title: '基层自报数据',
          name: 'behaviorManageSelfReportList',
        },],
      },
    },
  },
  // 医生估量列表
  {
    path: '/behaviorManage/doctors-estimate/page/:json',
    name: 'behaviorManageDoctorsEstimatePage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/doctors-estimate/page'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/work-center/self-report-data/doctors-estimate/Page.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '自报数据', //二级菜单
      title: '医生估量',
    },
  },
  //医生估量导入
  {
    path: '/behaviorManage/doctors-estimate/import',
    name: 'behaviorManageDoctorsEstimateImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimateImport" */
      //   '@/views/behaviorManage/doctors-estimate/import'
      // ), //待删除文件
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimateImport" */
        '@/views/behavior-manage/work-center/self-report-data/doctors-estimate/Import.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '自报数据', //二级菜单
      title: '导入医生估量',
      breadcrumb: [{
        title: '医生估量',
        name: 'behaviorManageDoctorsEstimatePage',
      },],
    },
  },
]
export default selfReportDataRouter